import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { NavigationEnd, Router, Event, RouterEvent } from '@angular/router'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Observable, of } from 'rxjs'
import { filter, switchMap } from 'rxjs/operators'

@UntilDestroy()
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BreadcrumbComponent implements OnInit {
  links$: Observable<Link[]>

  trackByLinks = (_: number, link: Link): string => {
    return link.name
  }

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.links$ = this.router.events.pipe(filter((e: Event | RouterEvent): e is RouterEvent => e instanceof NavigationEnd)).pipe(
      switchMap(event => {
        const links: Link[] = []
        const projectId = this.router.routerState.snapshot.root.firstChild?.firstChild?.paramMap?.get('projectId') // projects/:projectId
        const ahuId = this.router.routerState.snapshot.root.firstChild?.firstChild?.firstChild?.paramMap?.get('ahuId') // projects/:projectId/unit/:ahuId
        const { url } = event

        if (!projectId) {
          return of([])
        }

        links.push({
          name: 'UI.ProjectLink',
          url: `/projects/${projectId}`,
          active: !ahuId,
          next: false,
        } as Link)

        if (ahuId) {
          links.push({
            name: 'UI.UnitLink',
            url: `/projects/${projectId}/unit/${ahuId}`,
            active: !url.includes('/results'),
            next: false,
          })

          links.push({
            name: 'UI.Results',
            url: `/projects/${projectId}/unit/${ahuId}/results`,
            active: url.includes('/results'),
            next: !url.includes('/results'),
          })
        }

        return of(links)
      }),
      untilDestroyed(this),
    )
  }
}

export interface Link {
  name: string
  url: string
  active: boolean
  next: boolean
}
